import { Form, notification, QRCode } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import dayjs from "dayjs";
import { apiUrl, defaultProfile } from "../../../providers/companyInfo";
import { GET, POST } from "../../../providers/useAxiosQuery";

import PageApplicantFormContent from "./PageApplicantFormContent";
import {
	addApplicantFormOnFinish,
	editApplicantFormOnFinish,
} from "./components/PageApplicantFormOnfinish";
import generateRandomString from "../../../providers/generateRandomString";
import ModalUploadProfilePicture from "./components/ModalUploadProfilePicture";
import notificationErrors from "../../../providers/notificationErrors";
import convertQrCodeToImage from "../../../providers/convertQrCodeToImage";
import ModalAuthPassword from "./components/ModalAuthPassword";

export default function PageApplicantForm() {
	const location = useLocation();
	const params = useParams();
	const [form] = Form.useForm();
	const navigate = useNavigate();

	const [
		toggleModalUploadProfilePicture,
		setToggleModalUploadProfilePicture,
	] = useState({
		open: false,
		data: null,
		file: null,
		src: null,
		is_camera: null,
		fileName: null,
	});

	const [toggleModalProfile, setToggleModalProfile] = useState({
		open: false,
		data: null,
	});

	const [toggleModalAuthPassword, setToggleModalAuthPassword] = useState({
		open: false,
		data: null,
	});

	const { stateDataConsent } = location.state || {};

	const [qrCode, setQrCode] = useState("");
	const [qrCodeFile, setQrCodeFile] = useState("");
	const [scholarship, setScholarship] = useState("");
	const [examSchedule, setExamSchedule] = useState();
	const [selectedStudentLevel, setSelectedStudentLevel] = useState();
	const [formData, setFormData] = useState(null);

	const { mutate: mutateStudentCreate, isLoading: isLoadingStudent } = POST(
		`api/student_exams`,
		"student_exams_list"
	);

	const {
		mutate: mutateApplicantUpdate,
		isLoading: isLoadingUpdateChanges,
	} = POST(`api/update_student_basic_info`, `student_exams_list`);

	const capitalizeWords = (str) =>
		str
			.split(" ")
			.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
			.join(" ");

	const handleFinish = (values, authPassword) => {
		const props = {
			form,
			formData,
			stateDataConsent,
			dayjs,
			location,
			notification,
			notificationErrors,
			qrCode,
			setQrCodeFile,
			toggleModalUploadProfilePicture,
			setToggleModalProfile,
			setToggleModalAuthPassword,
			convertQrCodeToImage,
			capitalizeWords,

			mutateStudentCreate,
			mutateApplicantUpdate,
		};

		if (location.pathname.includes("add")) {
			addApplicantFormOnFinish(props, values, location, params, navigate);
		} else if (location.pathname.includes("edit")) {
			editApplicantFormOnFinish(props, values, location, params, authPassword);
		}
	};

	const formId = location.pathname.includes("/applicants")
		? "PageApplicantForm"
		: location.pathname.includes("/profiling-portal/add")
		? "PageProfilingPortalAdd"
		: "PageProfilingPortalEdit";

	if (location.pathname.includes("edit")) {
		GET(
			`api/student_exams/${params.id}`,
			["student_exams_info", "check_user_permission"],
			(res) => {
				if (res.data) {
					let data = res.data;

					let contact_number = null;
					if (
						data.profile_contact_informations &&
						data.profile_contact_informations.length
					) {
						contact_number = data.profile_contact_informations.filter(
							(item) => item.status === 1
						)[0].contact_number;
					}

					let personal_email = null;
					if (
						data.profile_contact_informations &&
						data.profile_contact_informations.length
					) {
						personal_email = data.profile_contact_informations.filter(
							(item) => item.status === 1
						)[0].email;
					}
					let language =
						data.profile_languages
							?.filter((item) => item.status === 1)
							.map((item) => item.language) || [];

					// Studen Exam Qr
					let qrCode = null;
					if (data.student_exam_qrs && data.student_exam_qrs.length > 0) {
						qrCode =
							data.student_exam_qrs[data.student_exam_qrs.length - 1].qr_code;
						setQrCode(qrCode);
					}

					// Health Information
					let have_disability = null;
					let disability_type = null;
					let other_disability = null;
					let have_difficulty = null;
					let difficulty_type = null;
					let other_difficulty = null;

					if (
						data.profile_health_informations &&
						data.profile_health_informations.length > 0
					) {
						have_disability =
							data.profile_health_informations[0].have_disability;
						disability_type =
							data.profile_health_informations[0].disability_type;
						other_disability =
							data.profile_health_informations[0].other_disability;
						have_difficulty =
							data.profile_health_informations[0].have_difficulty;
						difficulty_type =
							data.profile_health_informations[0].difficulty_type;
						other_difficulty =
							data.profile_health_informations[0].other_difficulty;
					}

					// Exam Information
					let student_level_id = null;
					let current_course_id = null;
					let student_track = null;
					let student_strand = null;
					let first_course_id = null;
					let second_course_id = null;
					let third_course_id = null;
					let student_status = null;
					let previous_school_name = null;
					let previous_school_year = null;
					let applied_to_fsuu = null;
					let year_applied = null;
					let accepted_to_fsuu = null;
					let year_accepted = null;
					let attended_to_fsuu = null;
					let year_attended = null;

					if (data.student_academics && data.student_academics.length > 0) {
						student_level_id = data.student_academics[0].student_level_id;
						current_course_id = data.student_academics[0].current_course_id;
						student_track = data.student_academics[0].student_track;
						student_strand = data.student_academics[0].student_strand;
						first_course_id = data.student_academics[0].first_course_id;
						second_course_id = data.student_academics[0].second_course_id;
						third_course_id = data.student_academics[0].third_course_id;
						student_status = location.pathname.includes(
							"/profiling-portal/edit"
						)
							? ""
							: data.student_academics[0].student_status;

						// For Transferee
						previous_school_name =
							data.student_academics[0].previous_school_name;
						previous_school_year = data.student_academics[0]
							.previous_school_year
							? dayjs(data.student_academics[0].previous_school_year)
							: null;
						applied_to_fsuu = data.student_academics[0].applied_to_fsuu;
						year_applied = data.student_academics[0].year_applied
							? dayjs(data.student_academics[0].year_applied)
							: null;
						accepted_to_fsuu = data.student_academics[0].accepted_to_fsuu;
						year_accepted = data.student_academics[0].year_accepted
							? dayjs(data.student_academics[0].year_accepted)
							: null;
						attended_to_fsuu = data.student_academics[0].attended_to_fsuu;
						year_attended = data.student_academics[0].year_attended
							? dayjs(data.student_academics[0].year_attended)
							: null;
					}

					let exam_schedule_id = null;
					let exam_category_id = null;

					if (
						data.student_academics &&
						data.student_academics.length > 0 &&
						data.student_academics[0].student_exams &&
						data.student_academics[0].student_exams.length > 0
					) {
						exam_schedule_id = location.pathname.includes(
							"/profiling-portal/edit"
						)
							? ""
							: Number(
									data.student_academics[0].student_exams[0].exam_schedule_id
							  );

						setExamSchedule(exam_schedule_id);

						exam_category_id = location.pathname.includes(
							"/profiling-portal/edit"
						)
							? ""
							: Number(
									data.student_academics[0].student_exams[0].exam_category_id
							  );

						// Exam Schedule
					}

					let apply_scholarship = null;
					let scholarship_id = null;

					if (data.student_academics && data.student_academics.length > 0) {
						scholarship_id = data.student_academics[0].scholarship_id;
						apply_scholarship = data.student_academics[0].apply_scholarship;
					}

					// Profile Picture
					if (data && data.attachments && data.attachments.length > 0) {
						const profileAttachments = data.attachments.filter(
							(attachment) =>
								attachment.file_description === "Applicant Profile"
						);

						if (profileAttachments.length > 0) {
							setToggleModalUploadProfilePicture((ps) => ({
								...ps,
								src: apiUrl(
									profileAttachments[profileAttachments.length - 1].file_path
								),
							}));
						} else {
							setToggleModalUploadProfilePicture((ps) => ({
								...ps,
								src: defaultProfile,
							}));
						}
					}

					setScholarship(scholarship_id);
					setSelectedStudentLevel(student_level_id);

					form.setFieldsValue({
						username: data.user.username ?? undefined,
						email: data.user.email ?? undefined,

						// Personal Information
						firstname: data.firstname ?? undefined,
						middlename: data.middlename ?? undefined,
						lastname: data.lastname ?? undefined,
						name_ext: data.name_ext ?? undefined,
						birthplace: data.birthplace ?? undefined,
						birthdate: data.birthdate ? dayjs(data.birthdate) : undefined,
						age: data.age ?? undefined,
						gender: data.gender ?? undefined,
						language: language && language.length > 0 ? language : null,
						blood_type: data.blood_type ?? undefined,
						height: data.height ?? undefined,
						weight: data.weight ?? undefined,
						religion_id: data.religion_id ?? undefined,
						nationality_id: data.nationality_id ?? undefined,
						civil_status_id: data.civil_status_id ?? undefined,
						contact_number: contact_number ?? undefined,
						personal_email: personal_email ?? undefined,

						// Health Information
						have_disability: have_disability ?? undefined,
						disability_type: disability_type ?? undefined,
						other_disability: other_disability ?? undefined,
						have_difficulty: have_difficulty ?? undefined,
						difficulty_type: difficulty_type ?? undefined,
						other_difficulty: other_difficulty ?? undefined,

						// Exam Information
						student_level_id: student_level_id ?? undefined,
						current_course_id: current_course_id ?? undefined,
						student_track: student_track ?? undefined,
						student_strand: student_strand ?? undefined,
						exam_schedule_id: exam_schedule_id ?? undefined,
						exam_category_id: exam_category_id ?? undefined,
						scholarship_id: scholarship_id ?? undefined,
						apply_scholarship: apply_scholarship ?? undefined,

						student_status: student_status ?? undefined,
						first_course_id: first_course_id ?? undefined,
						second_course_id: second_course_id ?? undefined,
						third_course_id: third_course_id ?? undefined,

						previous_school_name: previous_school_name ?? undefined,
						previous_school_year: previous_school_year ?? undefined,
						applied_to_fsuu: applied_to_fsuu ?? undefined,
						year_applied: year_applied ?? undefined,
						accepted_to_fsuu: accepted_to_fsuu ?? undefined,
						year_accepted: year_accepted ?? undefined,
						attended_to_fsuu: attended_to_fsuu ?? undefined,
						year_attended: year_attended ?? undefined,
					});
				}
			}
		);
	}

	useEffect(() => {
		setQrCode(generateRandomString(10));
	}, [params]);

	useEffect(() => {
		if (location.pathname.includes("/add")) {
			if (!stateDataConsent) {
				// Redirect to the consent form if stateDataConsent is not present
				if (location.pathname.includes("/profiling-portal")) {
					navigate("/profiling-portal");
				} else {
					navigate("/applicants/walk-in");
				}
			}
		}
	}, [stateDataConsent, navigate, location.pathname]);

	return (
		<Form
			onFinish={handleFinish}
			form={form}
			initialValues={{
				address_list: [{}],
				school_attended_list: [{}],
				parent_list: [{}],
			}}
			scrollToFirstError={{
				behavior: "smooth",
				block: "center",
			}}
			id={formId}
		>
			{qrCode && (
				<div
					id="myqrcode"
					style={{
						visibility: "hidden",
						height: 0,
						overflow: "hidden",
					}}
				>
					<QRCode
						errorLevel="H"
						value={`${window.location.origin}/payment-qrscan/${qrCode}`}
						icon="/images/logo.png"
						bgColor="#ffffff"
						size={300}
						type="svg"
					/>
				</div>
			)}

			<img
				id="img_fsuulogo"
				alt="fsuulogo"
				src="/assets/images/logo.png"
				style={{ display: "none" }}
			/>

			<PageApplicantFormContent
				form={form}
				qrCode={qrCode}
				setQrCode={setQrCode}
				setScholarship={setScholarship}
				stateDataConsent={stateDataConsent}
				setFormData={setFormData}
				examSchedule={examSchedule}
				setExamSchedule={setExamSchedule}
				toggleModalUploadProfilePicture={toggleModalUploadProfilePicture}
				setToggleModalUploadProfilePicture={setToggleModalUploadProfilePicture}
				toggleModalProfile={toggleModalProfile}
				setToggleModalProfile={setToggleModalProfile}
				toggleModalAuthPassword={toggleModalAuthPassword}
				setToggleModalAuthPassword={setToggleModalAuthPassword}
				selectedStudentLevel={selectedStudentLevel}
				setSelectedStudentLevel={setSelectedStudentLevel}
			/>

			<ModalUploadProfilePicture
				toggleModalUploadProfilePicture={toggleModalUploadProfilePicture}
				setToggleModalUploadProfilePicture={setToggleModalUploadProfilePicture}
			/>

			<ModalAuthPassword
				toggleModalAuthPassword={toggleModalAuthPassword}
				setToggleModalAuthPassword={setToggleModalAuthPassword}
				handleFinish={handleFinish}
			/>
		</Form>
	);
}
